<template>
  <VApp id="inspire">
    <template v-if="isAuth">
      <VNavigationDrawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        fixed
        app
      >
        <SidebarBlock />
      </VNavigationDrawer>
      <VToolbar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="primary"
        dark
        app
        fixed
      >
        <VToolbarTitle
          style="width: 400px"
          class="ml-0 pl-3"
        >
          <VToolbarSideIcon @click.stop="drawer = !drawer" />
          <span class="hidden-sm-and-down">
            Elsazeit Partnerprogramm
          </span>
        </VToolbarTitle>
        <!--<v-text-field  flat  solo-inverted  hide-details  prepend-inner-icon="search"  :label="$nt('search')"  class="hidden-sm-and-down"/>-->
        <VSpacer />
        <NotificationBlock />
        <VToolbarItems v-if="isAuth">
          <VBtn
            flat
            @click="logout"
          >
            {{ $nt('logoutText') }}
          </VBtn>
        </VToolbarItems>
      </VToolbar>
    </template>

    <VContent>
      <VContainer fluid>
        <VLayout
          align-center
          justify-center
        >
          <slot />
          <GlobalNotifications />
        </VLayout>
      </VContainer>
    </VContent>
  </VApp>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NotificationBlock from '@/components/layouts/parts/NotificationBlock'
import SidebarBlock from '@/components/layouts/parts/SidebarBlock'
import GlobalNotifications from '@/components/layouts/parts/GlobalNotifications'
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/webapp/app.scss'

export default {
  name: 'AppLayout',
  components: { GlobalNotifications, SidebarBlock, NotificationBlock },
  data: () => ({
    dialog: false,
    drawer: null
  }),
  computed: {
    ...mapGetters('user', ['isAuth'])
  },
  methods: {
    ...mapActions('user', ['logout'])
  },
  mounted () {
    setLayoutClass('layout-webapp')
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
</style>
